export default __webpack_public_path__ + "static/media/Me-documentation.204d15e2.md";